module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Settlement Create")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('a', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "href": ((this.$axios.defaults.baseURL) + "/sattlement/export/excel")
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" Download Excel\r\n            ")]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "branch_id",
      "label": "name",
      "options": _vm.branches,
      "placeholder": "Select Branch"
    },
    on: {
      "input": _vm.getLoanMember
    },
    model: {
      value: (_vm.branch),
      callback: function($$v) {
        _vm.branch = $$v
      },
      expression: "branch"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.planType),
      expression: "form.planType"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('planType')
    },
    attrs: {
      "name": "planType"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "planType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.getLoanMember]
    }
  }, [(!_vm.form.planType) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\r\n                      Select plan Type\r\n                    ")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "individual"
    }
  }, [_vm._v("Individual")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "group"
    }
  }, [_vm._v("Group")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "planType"
    }
  })], 1)]), _vm._v(" "), (_vm.form.planType == 'group') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Group ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "collection_center_id",
      "label": "name",
      "options": _vm.collectionCenters,
      "placeholder": "Select Group"
    },
    on: {
      "input": _vm.getLoanMember
    },
    model: {
      value: (_vm.colC),
      callback: function($$v) {
        _vm.colC = $$v
      },
      expression: "colC"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "collection_center_id"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group bg-light"
  }, [_vm._m(3), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "member_id",
      "label": "name",
      "options": _vm.memberloanplans,
      "placeholder": "Select Member"
    },
    on: {
      "input": _vm.getMemberLoanDetail
    },
    model: {
      value: (_vm.mem),
      callback: function($$v) {
        _vm.mem = $$v
      },
      expression: "mem"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "member_id"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "member_id"
    }
  })], 1)])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.editMode ? _vm.updateLoanSettlement() : _vm.loanSettlement()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Plan Name ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.planName),
      expression: "form.planName"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('planName')
    },
    attrs: {
      "type": "text",
      "name": "planName",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.form.planName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "planName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "planName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Total Installment Paid")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.totalInstallmentPaid),
      expression: "form.totalInstallmentPaid"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('totalInstallmentPaid'),
    },
    attrs: {
      "type": "text",
      "name": "totalInstallmentPaid",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.form.totalInstallmentPaid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "totalInstallmentPaid", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "totalInstallmentPaid"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Reason ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.reason),
      expression: "form.reason"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('reason')
    },
    attrs: {
      "name": "reason",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "reason", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "PrePayment"
    }
  }, [_vm._v("PrePayment")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Death"
    }
  }, [_vm._v("Death (Account Closed)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "First-Payment-Default"
    }
  }, [_vm._v("X01 -> First Payment Default")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Death-Written-off"
    }
  }, [_vm._v("X02 -> Death (Written-off)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Written-off"
    }
  }, [_vm._v("X02 -> Written-off")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Settled"
    }
  }, [_vm._v("X03 -> Settled")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Willful-Default-Status"
    }
  }, [_vm._v("X03 -> Willful Default Status")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Suilt-Field-Willful-Default-Status"
    }
  }, [_vm._v("X04 -> Suilt Field, Willful Default Status")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Untagged"
    }
  }, [_vm._v("X09 -> Untagged")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Not-Applicable"
    }
  }, [_vm._v("X10 -> Not Applicable")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "reason"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Loan Pre Closing Charge Type ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.loanPreClosingChargeType),
      expression: "form.loanPreClosingChargeType"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('loanPreClosingChargeType')
    },
    attrs: {
      "name": "loanPreClosingChargeType",
      "required": "",
      "readonly": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "loanPreClosingChargeType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "percent"
    }
  }, [_vm._v("Percent")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "loanPreClosingChargeType"
    }
  })], 1), _vm._v(" "), (_vm.form.loanPreClosingCharge > 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Total Amount Due With Pre Loan Closing Charge ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.totalAmtDueWithPreClosingCharge),
      expression: "form.totalAmtDueWithPreClosingCharge"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('totalAmtDueWithPreClosingCharge')
    },
    attrs: {
      "type": "text",
      "name": "totalAmtDueWithPreClosingCharge",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.form.totalAmtDueWithPreClosingCharge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "totalAmtDueWithPreClosingCharge", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "totalAmtDueWithPreClosingCharge"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.mem) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editMode),
      expression: "!editMode"
    }],
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\r\n                    CREATE SETTLEMENT\r\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.mem) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode),
      expression: "editMode"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\r\n                     UPDATE SETTLEMENT\r\n                  ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Total Amount ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.planAmount),
      expression: "form.planAmount"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('planAmount')
    },
    attrs: {
      "type": "text",
      "name": "planAmount",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.form.planAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "planAmount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "planAmount"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Total Amount Paid")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.totalAmountPaid),
      expression: "form.totalAmountPaid"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('totalAmountPaid'),
    },
    attrs: {
      "type": "text",
      "name": "totalAmountPaid",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.form.totalAmountPaid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "totalAmountPaid", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "totalAmountPaid"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Total Amount Due Without Interest")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.totalAmountDueWithoutInterest),
      expression: "form.totalAmountDueWithoutInterest"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'totalAmountDueWithoutInterest'
      ),
    },
    attrs: {
      "type": "text",
      "name": "totalAmountDueWithoutInterest",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.form.totalAmountDueWithoutInterest)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "totalAmountDueWithoutInterest", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "totalAmountDueWithoutInterest"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Total Current Due Amount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.amt),
      expression: "form.amt"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'amt'
      ),
    },
    attrs: {
      "type": "text",
      "name": "amt",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.form.amt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "amt", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "amt"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.mem) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.newModal
    }
  }, [_vm._v("\r\n                    COLLECT CURRENT DUE\r\n                  ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Application Number ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.applicationNumber),
      expression: "form.applicationNumber"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('applicationNumber'),
    },
    attrs: {
      "type": "text",
      "name": "applicationNumber",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.form.applicationNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "applicationNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "applicationNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Total Installment Due")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.totalInstallmentDue),
      expression: "form.totalInstallmentDue"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('totalInstallmentDue'),
    },
    attrs: {
      "type": "text",
      "name": "totalInstallmentDue",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.form.totalInstallmentDue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "totalInstallmentDue", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "totalInstallmentDue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Payment Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.sattlementDate),
      expression: "form.sattlementDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('sattlementDate'),
    },
    attrs: {
      "type": "date",
      "name": "sattlementDate"
    },
    domProps: {
      "value": (_vm.form.sattlementDate)
    },
    on: {
      "change": _vm.settmentDateWise,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "sattlementDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "sattlementDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Ledger Account ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_ledger_id),
      expression: "form.branch_ledger_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_ledger_id'),
    },
    attrs: {
      "name": "branch_ledger_id"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_ledger_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.branch_ledger_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\r\n                      Select Ledger Account\r\n                    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.payment_ledgers), function(brLedger) {
    return _c('option', {
      key: brLedger.id,
      domProps: {
        "value": brLedger.id
      }
    }, [_vm._v("\r\n                      " + _vm._s(brLedger.name) + " " + _vm._s(brLedger.remark) + "\r\n                    ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_ledger_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Remark")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.remark),
      expression: "form.remark"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'remark'
      ),
    },
    attrs: {
      "type": "text",
      "name": "remark"
    },
    domProps: {
      "value": (_vm.form.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "remark", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "remark"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Member Name ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.memberName),
      expression: "form.memberName"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('memberName')
    },
    attrs: {
      "type": "text",
      "name": "memberName",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.form.memberName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "memberName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "memberName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Total Amount Due")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.totalAmountDue),
      expression: "form.totalAmountDue"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('totalAmountDue'),
    },
    attrs: {
      "type": "text",
      "name": "totalAmountDue",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.form.totalAmountDue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "totalAmountDue", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "totalAmountDue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Loan Pre Closing Charge (%)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.loanPreClosingCharge),
      expression: "form.loanPreClosingCharge"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'loanPreClosingCharge'
      ),
    },
    attrs: {
      "type": "number",
      "step": ".01",
      "name": "loanPreClosingCharge"
    },
    domProps: {
      "value": (_vm.form.loanPreClosingCharge)
    },
    on: {
      "change": _vm.afterAmtLoanPreClosingCharge,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "loanPreClosingCharge", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "loanPreClosingCharge"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Total Amount Paid Settlement")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.totalAmountPaidWithSettlement),
      expression: "form.totalAmountPaidWithSettlement"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'totalAmountPaidWithSettlement'
      ),
    },
    attrs: {
      "type": "number",
      "required": "",
      "name": "totalAmountPaidWithSettlement"
    },
    domProps: {
      "value": (_vm.form.totalAmountPaidWithSettlement)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "totalAmountPaidWithSettlement", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "totalAmountPaidWithSettlement"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_vm._v("\r\n          List of all Settlement\r\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "box info-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._v("\r\n          Search By\r\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.canAccess('branch-create')) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Branch"
    }
  }, [_vm._v("Branch")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "branch_id",
      "label": "name",
      "options": _vm.branches,
      "placeholder": "Select Branch"
    },
    on: {
      "input": _vm.branchRecordWithLoadSettlementData
    },
    model: {
      value: (_vm.branchFilter),
      callback: function($$v) {
        _vm.branchFilter = $$v
      },
      expression: "branchFilter"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.planType == 'group') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Collection Center ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "collection_center_id",
      "label": "name",
      "options": _vm.collectionCenters,
      "placeholder": "Select Group",
      "required": ""
    },
    on: {
      "input": _vm.loadSettlementData
    },
    model: {
      value: (_vm.colC),
      callback: function($$v) {
        _vm.colC = $$v
      },
      expression: "colC"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Customer")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "collection_center_id",
      "label": "name",
      "options": _vm.members,
      "placeholder": "Select Group",
      "required": ""
    },
    on: {
      "input": _vm.loadSettlementDataWithCustomer
    },
    model: {
      value: (_vm.member),
      callback: function($$v) {
        _vm.member = $$v
      },
      expression: "member"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.paymentDate),
      expression: "form.paymentDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "paymentDate",
      "placeholder": "EMI Date"
    },
    domProps: {
      "value": (_vm.form.paymentDate)
    },
    on: {
      "change": function($event) {
        return _vm.loadSettlementData(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "paymentDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status),
      expression: "form.status"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('status'),
    },
    attrs: {
      "name": "status"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.loadSettlementData]
    }
  }, [(!_vm.form.status) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\r\n                    Select Status\r\n                  ")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pending"
    }
  }, [_vm._v("Pending")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "processing"
    }
  }, [_vm._v("Processing")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "sattlement"
    }
  }, [_vm._v("Settlement")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "complete"
    }
  }, [_vm._v("Complete")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "status"
    }
  })], 1)])])])]), _vm._v(" "), (_vm.canAccess('bank-view-any')) ? _c('div', {
    staticClass: "info-box"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [_c('label', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.per_page),
      expression: "per_page"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "name": "per_page",
      "aria-controls": "example1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.per_page = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.loadSettlementData()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("100")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [_c('div', {
    staticClass: "input-group pull-right input-group-sm",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.table_search),
      expression: "table_search"
    }],
    staticClass: "form-control pull-right",
    attrs: {
      "type": "text",
      "name": "table_search",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.table_search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.loadSettlementData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.table_search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadSettlementData()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-bordered table-hover"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.rows.data), function(row, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s((index + _vm.pagination.from)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.member_loan_plan.applicationNo))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.member.name) + " - " + _vm._s(row.member.code))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.member.alias))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.member.mobile))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.planAmount))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.totalAmountPaid))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.totalAmountDue))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.totalAmountPaidWithSettlement))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm._f("myDate")(row.sattlementDate)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.created_by.name))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.branch_ledger.ledger.name))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.status))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "btn-group"
    }, [(row.status !== 'approved') ? _c('button', {
      staticClass: "btn btn-success btn-xs",
      on: {
        "click": function($event) {
          return _vm.editModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success btn-xs",
      on: {
        "click": function($event) {
          return _vm.viewModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success btn-xs",
      on: {
        "click": function($event) {
          return _vm.viewPrintModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-print"
    })]), _vm._v(" "), (_vm.canAccess('loan-disbursement-delete')) ? _c('button', {
      staticClass: "btn btn-danger btn-xs",
      on: {
        "click": function($event) {
          return _vm.deleteModal(row.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()])])])
  }), 0)])]), _vm._v(" "), (_vm.pagination.current_page > 0) ? _c('div', {
    staticClass: "box-footer clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("\r\n              Showing " + _vm._s(_vm.pagination.from) + " to " + _vm._s(_vm.pagination.to) + " of " + _vm._s(_vm.pagination.total) + " entries\r\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('ul', {
    staticClass: "pagination pagination-sm no-margin pull-right"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(null, 'first')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("«")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(null, 'prev')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Prev")])]), _vm._v(" "), (_vm.pagination.current_page > 3) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.current_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 2) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.current_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 1) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.current_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "active",
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.current_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page))])]), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 4)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.current_page + 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 1))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 5)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.current_page + 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 6)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.current_page + 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 3))])]) : _vm._e(), _vm._v(" "), _vm._m(7), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 3)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.last_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 2)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.last_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 1)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.last_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(_vm.pagination.last_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page))])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(null, 'next')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Next")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.loadSettlementData(null, 'last')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("»")])])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [(_vm.settlementDetails) ? _c('div', {
    staticClass: "card-body"
  }, [_c('ul', {
    staticClass: "todo-list ui-sortable",
    attrs: {
      "data-widget": "todo-list"
    }
  }, [(_vm.settlementDetails.branch) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Branch Name : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.branch.name) + "\r\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.branch_ledger) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Payment Mode : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.branch_ledger.ledger.name) + "\r\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.member) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Member Name : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.member.name) + "\r\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.member) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Member code : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.member.code) + "\r\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.member) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Member Alias : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.member.alias) + "\r\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.member) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Member Contact Number : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.member.mobile) + "\r\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.member) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Member Email : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.member.email) + "\r\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.member_loan_plan) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Loan Application Number : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.member_loan_plan.applicationNo) + "\r\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.member_loan_plan) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Loan EMI Start Date : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.member_loan_plan.emiStartDate) + "\r\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.member_loan_plan) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Loan EMI End Date : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.member_loan_plan.emiEndDate) + "\r\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.member_loan_plan) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Loan Type : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.member_loan_plan.type) + "\r\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.settlementDetails.collection_center) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Collection Center : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.collection_center.name) + "\r\n                        ")]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Total Plan amount : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.planAmount) + "\r\n                        ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Total Amount Paid : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.totalAmountPaid) + "\r\n                        ")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('ul', {
    staticClass: "todo-list ui-sortable",
    attrs: {
      "data-widget": "todo-list"
    }
  }, [_c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Total Amount Due Without Interest : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.totalAmountDueWithoutInterest) + "\r\n                      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Total Amount Due : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.totalAmountDue) + "\r\n                      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Total Installment Paid : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.totalInstallmentPaid) + "\r\n                      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Total Installment Due : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.totalInstallmentDue) + "\r\n                      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Loan Pre Closing Charge Type : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.loanPreClosingChargeType) + "\r\n                      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("loanPreClosingCharge (%) : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.loanPreClosingCharge) + "\r\n                      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Reason : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.reason) + "\r\n                      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Settlement Date : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.sattlementDate) + "\r\n                      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Remark : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.remark) + "\r\n                      ")]), _vm._v(" "), (_vm.settlementDetails.created_by) ? _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Loan Settled By : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.created_by.name) + "\r\n                      ")]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Total Amount Paid With Settlement : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.totalAmountPaidWithSettlement) + "\r\n                      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "text"
  }, [_vm._v("Settlement Status : ")]), _vm._v(" " + _vm._s(_vm.settlementDetails.status) + "\r\n                      ")])])])])])]), _vm._v(" "), _vm._m(9)])])]), _vm._v(" "), _c('VIEWPRINTSETTLEMENT', {
    attrs: {
      "seeRecordSettlement": _vm.seeRecordSettlement
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "newModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(10), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editMode),
      expression: "!editMode"
    }],
    staticClass: "modal-title"
  }, [_vm._v("Payment Collection")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.collectPayment()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(11), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.amt),
      expression: "form.amt"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('amt')
    },
    attrs: {
      "type": "text",
      "name": "amt",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.amt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "amt", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "amt"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Ledger Account ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_ledger_id),
      expression: "form.branch_ledger_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_ledger_id'),
    },
    attrs: {
      "name": "branch_ledger_id"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_ledger_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.branch_ledger_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\r\n                                Select Ledger Account\r\n                              ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.brLedgers), function(brLedger) {
    return _c('option', {
      key: brLedger.id,
      domProps: {
        "value": brLedger.id
      }
    }, [_vm._v("\r\n                                " + _vm._s(brLedger.name) + " " + _vm._s(brLedger.remark) + "\r\n                              ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_ledger_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(12), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.paymentDate),
      expression: "form.paymentDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('paymentDate'),
    },
    attrs: {
      "type": "date",
      "name": "paymentDate",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.paymentDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "paymentDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "paymentDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(13), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.attendance),
      expression: "form.attendance"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('attendance'),
    },
    attrs: {
      "name": "attendance"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "attendance", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": "present"
    }
  }, [_vm._v("Present")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "absent"
    }
  }, [_vm._v("Absent")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "attendance"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Remark ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.remark),
      expression: "form.remark"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('remark')
    },
    attrs: {
      "type": "text",
      "name": "remark"
    },
    domProps: {
      "value": (_vm.form.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "remark", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "remark"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.mem) ? _c('div', {
    staticClass: "box box-default"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "callout callout-info"
  }, [_c('h4', [_vm._v("Member")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.mem.name))]), _vm._v(" "), _c('h4', [_vm._v("Mobile No")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.mem.mobile))])])])]) : _vm._e()])])])])]), _vm._v(" "), _vm._m(15)])])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "",
      "data-original-title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Select Branch "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Plan Type "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Select Member Id "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Select Status "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Settlement List")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "background-color": "#d6dddd"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Sr. No.")]), _vm._v(" "), _c('th', [_vm._v("Loan Id")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Mem Name")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("(C/O) Alias")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Mem Mob")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Plan Amt")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Paid Amt")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Due Amt")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Settle Amt")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Settle Date")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Created By")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Pay Mode")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Settlement Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Amount "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Payment Date "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Attendance "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-bullhorn"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Customer Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\r\n                  CREATE\r\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\r\n                  CANCEL\r\n                ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0b9d1940!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/entry/Settlement.vue
// module id = 810
// module chunks = 0